module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "x2fm-ttl"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "prologue"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062030580_Prologue"
    }
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part-i"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062030580_Part_1#part-i"
    }
  }, [_vm._v("Part I")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_1#chapter-1"
    }
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_2#chapter-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_3#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-4"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_4#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-5"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_5#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-6"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_6#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-7"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_7#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-8"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_8#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-9"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_9#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-10"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_10#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-11"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_11#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-12"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_12#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-13"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_13#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-14"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_14#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-15"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_15#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-16"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_16#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-17"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_17#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-18"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_18#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-19"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_19#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-20"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_20#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-21"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_21#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-22"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_22#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-23"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_23#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part-ii"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Part_2#part-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-24"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_24#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-25"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_25#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-26"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_26#chapter-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-27"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_27#chapter-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-28"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_28#chapter-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-29"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_29#chapter-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-30"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_30#chapter-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-31"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_31#chapter-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-32"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_32#chapter-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-33"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_33#chapter-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-34"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_34#chapter-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-35"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_35#chapter-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-36"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_36#chapter-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-37"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_37#chapter-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-38"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_38#chapter-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-39"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_39#chapter-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-40"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_40#chapter-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-41"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_41#chapter-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part-iii"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Part_3#part-iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-42"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_42#chapter-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-43"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_43#chapter-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-44"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_44#chapter-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-45"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_45#chapter-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-46"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_46#chapter-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-47"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_47#chapter-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-48"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_48#chapter-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter-49"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Chapter_49#chapter-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epilogue"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Acknowledgments#acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "also-by-the-author"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_AlsoBy#also-by-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Sandra Rodriguez Barron")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "credits"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Credits#credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062030580_Copyright#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878ace2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062030580_Contents.vue
// module id = 66
// module chunks = 0